import { InteractionType } from "@azure/msal-browser";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import { Flex } from "@fluentui/react-northstar";
import React from "react";

import { MicrosoftSignIn } from "../_shared/components/MicrosoftSignIn";
import { getPageContext } from "../_shared/utils/teamsHelpers";
import { pca } from "../App";
import { PageHeader } from "./PageHeader";
import { useMicrosoftAuth } from "./useMicrosoftAuth";

type Props = {
  title?: React.ReactNode;
  interactionType?: InteractionType;
};

export const MSALPageHost: React.FC<Props> = ({ children, ...props }) => {
  return (
    <MsalProvider instance={pca}>
      <Flex column>
        <PageHeader
          helpLink={
            getPageContext() === "/agile"
              ? {
                  url: "https://www.polly.ai/help/microsoft-teams/buying-polly",
                  label: "What is this?",
                }
              : undefined
          }
        />
        <Flex.Item grow>
          <LoginTemplate {...props}>{children}</LoginTemplate>
        </Flex.Item>
      </Flex>
    </MsalProvider>
  );
};

const LoginTemplate: React.FC<Props> = ({ interactionType, title, children }) => {
  const { login } = useMicrosoftAuth(["openid", "profile"]);

  return (
    <>
      <UnauthenticatedTemplate>
        <Flex hAlign="center" vAlign="center">
          <Flex column gap="gap.small">
            {title && <div>{title}</div>}
            <MicrosoftSignIn
              onSignIn={async () => {
                await login(interactionType || InteractionType.Redirect, {
                  state: window.location.href,
                  redirectUri: `${window.location.origin}${getPageContext()}/content/blank.html`,
                  scopes: ["openid", "profile"],
                });
              }}
            />
          </Flex>
        </Flex>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
    </>
  );
};
